export const MMS_MAX_FILE_SIZE = 3.75 * 1024 * 1024;

export const MMS_MAX_ATTACHMENTS = 4;

export const MMS_ALLOWED_EXTENSIONS = ['.jpeg', '.jpg', '.png', '.gif', '.pdf'];

export const MMS_ALLOWED_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'application/pdf',
];

export const MMS_FILE_SIZE_ERROR_TOOLTIP = 'Attached files exceed the permitted size limit';
